import React, { useState, useContext } from 'react';

export const AlertContext = React.createContext({});

export const useAlert = () => useContext(AlertContext);

export default ({ children }) => {
  const [state, setState] = useState({});

  const setAlert = ({ text, type }) => {
    const getColor = type => {
      switch (type) {
        case 'success':
          return '#4caf50';
        case 'info':
          return '#2196f3';
        case 'error':
          return '#f44336';
        case 'warning':
          return '#ff9800';
        default:
          return '#2196f3';
      }
    };

    setState({ text, type, color: getColor(type) });
  };

  const value = {
    alert: state,
    setAlert
  };

  return (
    <AlertContext.Provider value={value}>{children}</AlertContext.Provider>
  );
};
